import React from 'react';
import About from '../components/About/About';
import Video from '../components/Video/Video';

const AboutPage = () => {
  return (
    <div>
      <About />
      <Video />
    </div>
  );
};

export default AboutPage;
